import { RootState } from '@app/redux/root-reducer';

export const selectAddPortfolioState = (store: RootState) => store.portfolioReducer.addPortfolio;
export const selectUpdatePortfolioState = (store: RootState) =>
  store.portfolioReducer.updatePortfolio;
export const selectPortfolioState = (store: RootState) => store.portfolioReducer.portfolio;
export const selectDeletePortfolioState = (store: RootState) =>
  store.portfolioReducer.deletePortfolio;
